// @react/hooks/useTaskTaskType.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { taskTaskTypeStore } from '@core/stores';

/**
 * React hook for TaskTypeDefinition operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useTaskTaskType } from '@react/hooks';
 *
 * const TaskTypeDefinitionList = observer(() => {
 *   const store = useTaskTaskType();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useTaskTaskType() {
  return taskTaskTypeStore;
}
